import { useEffect, useState } from "react";
import allCountryCodes from "../countryCodes";

export default function useCountryCode() {
  const [countryCode, setCountryCode] = useState();
  const [countryCodes, setCountryCodes] = useState([]);

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("userData"));

    if (data?.countryCodes) {
      setCountryCodes(data.countryCodes);

      const selectedCountryCode = localStorage.getItem("x-country-code");

      if (selectedCountryCode) {
        if (data.countryCodes.includes(selectedCountryCode)) {
          localStorage.setItem("x-country-code", selectedCountryCode);
          setCountryCode(selectedCountryCode);
        } else {
          localStorage.setItem("x-country-code", data.countryCodes[0]);
          setCountryCode(data.countryCodes[0]);
        }
      } else {
        localStorage.setItem("x-country-code", data.countryCodes[0]);
        setCountryCode(data.countryCodes[0]);
      }
    } else {
      // console.log("debug:", "no data");
    }
  }, []);

  const setSelectedCountryCode = (code) => {
    localStorage.setItem("x-country-code", code);
    setCountryCode(code);
    setTimeout(() => {
      document.location.reload();
    }, 300);
  };

  return {
    countryCode: countryCode || countryCodes[0],
    countryCodes: countryCodes
      ? countryCodes.map((cc) => ({
          value: cc,
          label: allCountryCodes[cc] || cc?.toUpperCase(),
        }))
      : [],
    setCountryCode: setSelectedCountryCode,
  };
}
